export default __webpack_public_path__ + "static/media/cif-ye.b4f818c7.svg";